(function () {

  'use strict';


  /* ========================================
     FORMAT RANGE
  ======================================== */

  function formatRange(value, unit) {

    if (!value || value === '-') {
      return '-';
    }


    var parts = value.split('|');


    if (parts.length !== 2) {
      return '-';
    }


    var min = parseFloat(parts[0]);
    var max = parseFloat(parts[1]);


    if (isNaN(min) || isNaN(max)) {
      return '-';
    }


    /* CM */

    if (unit === 'cm') {

      min = Math.round(min * 2.54);
      max = Math.round(max * 2.54);

      return min + '–' + max + ' cm';

    }


    /* IN */

    return min + '"–' + max + '"';

  }


  /* ========================================
     RENDER CHART
  ======================================== */

  function renderChart(chart) {

    if (!chart) {
      return;
    }


    var product =
      chart.getAttribute('data-product') || 'trunks';


    var unit =
      chart.getAttribute('data-unit') || 'in';


    var rows =
      chart.querySelectorAll('tbody tr');


    rows.forEach(function (row) {

      var waistbandValue =
        row.getAttribute(
          'data-' + product + '-waistband'
        );


      var waistValue =
        row.getAttribute(
          'data-' + product + '-waist'
        );


      var waistbandCell =
        row.querySelector('[data-pl-waistband]');


      var waistCell =
        row.querySelector('[data-pl-waist]');


      if (waistbandCell) {

        waistbandCell.textContent =
          formatRange(
            waistbandValue,
            unit
          );

      }


      if (waistCell) {

        waistCell.textContent =
          formatRange(
            waistValue,
            unit
          );

      }

    });

  }


  /* ========================================
     PRODUCT BUTTON
  ======================================== */

  function handleProductClick(button) {

    var chart =
      button.closest('[data-pl-size-chart]');


    if (!chart) {
      return;
    }


    var product =
      button.getAttribute('data-pl-product');


    if (!product) {
      return;
    }


    chart.setAttribute(
      'data-product',
      product
    );


    var buttons =
      chart.querySelectorAll('[data-pl-product]');


    buttons.forEach(function (item) {

      item.classList.remove('is-active');

      item.setAttribute(
        'aria-pressed',
        'false'
      );

    });


    button.classList.add('is-active');

    button.setAttribute(
      'aria-pressed',
      'true'
    );


    renderChart(chart);

  }


  /* ========================================
     UNIT BUTTON
  ======================================== */

  function handleUnitClick(button) {

    var chart =
      button.closest('[data-pl-size-chart]');


    if (!chart) {
      return;
    }


    var unit =
      button.getAttribute('data-pl-unit');


    if (!unit) {
      return;
    }


    chart.setAttribute(
      'data-unit',
      unit
    );


    var buttons =
      chart.querySelectorAll('[data-pl-unit]');


    buttons.forEach(function (item) {

      item.classList.remove('is-active');

      item.setAttribute(
        'aria-pressed',
        'false'
      );

    });


    button.classList.add('is-active');

    button.setAttribute(
      'aria-pressed',
      'true'
    );


    renderChart(chart);

  }


  /* ========================================
     GLOBAL CLICK EVENT

     IMPORTANT:
     AVONE can inject Page HTML after the
     original page has already loaded.

     Therefore we listen on document instead
     of binding directly to each button.
  ======================================== */

  document.addEventListener(
    'click',
    function (event) {


      /* PRODUCT */

      var productButton =
        event.target.closest(
          '[data-pl-product]'
        );


      if (productButton) {

        event.preventDefault();

        handleProductClick(
          productButton
        );

        return;

      }


      /* UNIT */

      var unitButton =
        event.target.closest(
          '[data-pl-unit]'
        );


      if (unitButton) {

        event.preventDefault();

        handleUnitClick(
          unitButton
        );

      }

    }
  );


})();